import * as defaultImport from "@splunk/visualizations/Column";
export * from "@splunk/visualizations/Column";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
